import { SORTING_DIRECTION } from 'src/constants/main';

export interface ICurrenciesFilters {
  search: string;
  perPage: number | undefined;
  sortField: CURRENCIES_SORT_COLUMN;
  sortDir: SORTING_DIRECTION;
}

export enum CURRENCIES_SORT_COLUMN {
  NAME = 'currency_name',
  SYMBOL = 'currency_symbol',
  CODE = 'currency_code',
  CORE_AR = 'currency_code_ar',
  MULTIPLIER = 'divided',
}

export interface ICurrencyValidation {
  currency_name: IDefaultCountryFieldValidation;
  currency_code: IDefaultCountryFieldValidation;
  currency_code_ar: IDefaultCountryFieldValidation;
  currency_symbol: IDefaultCountryFieldValidation;
  divided: IDefaultCountryFieldValidation;
}

export interface IDefaultCountryFieldValidation {
  state: boolean;
  errorText?: string;
}
